import { useState } from 'react'
import { Mail } from 'lucide-react'

interface EmailsFormProps {
  defaultValue: string
  onSubmit: (emails: string) => void
  isSubmitting: boolean
}

export function EmailsForm({
  defaultValue,
  onSubmit,
  isSubmitting,
}: EmailsFormProps) {
  const [value, setValue] = useState(defaultValue)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSubmit(value)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Correos
        </label>
        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="input min-h-[100px] resize-y"
          placeholder="Ingrese los correos separados por coma (,)"
        />
        <p className="text-xs text-gray-500 mt-1">
          Separe multiples correos con coma. Ej: correo1@mail.com, correo2@mail.com
        </p>
      </div>

      <button type="submit" disabled={isSubmitting} className="btn btn-primary flex items-center gap-1.5">
        <Mail size={16} />
        {isSubmitting ? 'Actualizando...' : 'Actualizar correos'}
      </button>
    </form>
  )
}
